<form class="row g-2" novalidate [formGroup]="leasingVehicleForm" (ngSubmit)="next()">
    <div class="col-sm-8">
        <label class="col-12 form-label m-0" for="expirationDate">Fecha vigencia</label>
        <div class="col-12 input-group">
            <input class="datepicker-here form-control digits" placeholder="yyyy-mm-dd" id="expirationDate"
                   name="expirationDate" formControlName="expirationDate" ngbDatepicker #d="ngbDatepicker"
                   (click)="d.toggle()">
        </div>
    </div>
    <div class="col-sm-6">
        <label class="col-12 form-label m-0" for="term">Plazo<span class="txt-danger"> *</span></label>
        <div class="col-12 custom-input">
            <input class="form-control" id="term" type="text" formControlName="term">
        </div>
    </div>
    <div class="col-sm-6">
        <label class="col-12 form-label m-0" for="contractNumber"># Contrato<span class="txt-danger"> *</span></label>
        <div class="col-12 custom-input">
            <input class="form-control" id="contractNumber" type="text" formControlName="contractNumber">
        </div>
    </div>
    <div class="col-sm-4">
        <label class="col-12 form-label m-0" for="commission">Comisión<span class="txt-danger"> *</span></label>
        <div class="col-12 input-group"><span class="input-group-text">$</span>
            <input class="form-control" type="text" id="commission" aria-label="($MXN)" formControlName="commission">
            <span class="input-group-text">MXN</span>
        </div>
    </div>
    <div class="col-sm-4">
        <label class="col-12 form-label m-0" for="consideration">Contraprestación<span class="txt-danger"> *</span></label>
        <div class="col-12 input-group"><span class="input-group-text">$</span>
            <input class="form-control" type="text" id="consideration" aria-label="($MXN)" formControlName="consideration">
            <span class="input-group-text">MXN</span>
        </div>
    </div>
    <div class="col-sm-4">
        <label class="col-12 form-label m-0" for="estimatedResidual">Residual Estimado<span class="txt-danger"> *</span></label>
        <div class="col-12 input-group"><span class="input-group-text">$</span>
            <input class="form-control" type="text" id="estimatedResidual" aria-label="($MXN)" formControlName="estimatedResidual">
            <span class="input-group-text">MXN</span>
        </div>
    </div>
    <div class="product-buttons mb-4">
        <button class="btn" type="submit">
            <div class="d-flex align-items-center gap-sm-2 gap-1">Guardar y continuar
                <app-common-svg-icons [icons]="'front-arrow'"></app-common-svg-icons>
            </div>
        </button>
    </div>
</form>